import { NgIf, NgStyle } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';

@Component({
  standalone: true,
  selector: 'app-qc-individual-analyses-checkbox',
  templateUrl: './qc-individual-analyses-checkbox.component.html',
  styleUrls: ['./qc-individual-analyses-checkbox.component.less'],
  viewProviders: [{provide: ControlContainer, useExisting: FormGroupDirective}],
  imports: [ReactiveFormsModule, NgIf, NgStyle]
})
export class QcIndividualAnalysesCheckboxComponent implements OnInit {

  @Input() name: string;
  @Input() label: string;
  @Input() code: string;
  @Input() stared: boolean;
  @Input() notEqual: boolean;
  @Input() small: boolean;

  constructor() { }

  ngOnInit() {
  }

}
